var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751",
    transform: "translate(1261 -4691)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_590",
    "data-name": "Ellipse 590",
    cx: 72,
    cy: 72,
    r: 72,
    transform: "translate(-1261 4691)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_001-user-1",
    "data-name": "001-user-1",
    transform: "translate(-1269.691 4701.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748",
    transform: "translate(47.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M143.583,0a32.792,32.792,0,1,0,32.792,32.792A32.879,32.879,0,0,0,143.583,0Z",
    transform: "translate(-110.791)",
    fill: "#2e2e2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750",
    transform: "translate(24.165 67.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M136.977,271.7a30.572,30.572,0,0,0-3.293-6.014,40.76,40.76,0,0,0-28.21-17.757,6.036,6.036,0,0,0-4.153,1,34.954,34.954,0,0,1-41.241,0,5.373,5.373,0,0,0-4.153-1,40.465,40.465,0,0,0-28.21,17.757,35.247,35.247,0,0,0-3.293,6.014,3.045,3.045,0,0,0,.143,2.721,57.126,57.126,0,0,0,3.866,5.728,54.418,54.418,0,0,0,6.587,7.446,85.826,85.826,0,0,0,6.587,5.728,65.3,65.3,0,0,0,77.9,0,62.96,62.96,0,0,0,6.587-5.728,66.127,66.127,0,0,0,6.587-7.446,50.205,50.205,0,0,0,3.866-5.728A2.444,2.444,0,0,0,136.977,271.7Z",
    transform: "translate(-24.165 -247.841)",
    fill: "#2e2e2e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f609985a90301fe08594d8d35b388850.svg";
export { ForwardRef as ReactComponent };